import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { validator } from "@/business/shared/commons/validator/validator";
import { PasswordRule } from "@/business/shared/commons/validator/rules/PasswordRule";

export function loginValidator() {
  const userName: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El nombre de usuario es obligatorio")],
  });
  const password: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("La contraseña es obligatoria")],
  });

  watch(
    () => userName.value.val,
    () => {
      if ((userName.value.val?.length ?? 0) > 0) {
        userName.value.enabled = true;
      }
    }
  );
  watch(
    () => password.value.val,
    () => {
      if ((password.value.val?.length ?? 0) > 0) {
        password.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    userName.value = validate(userName.value);
    password.value = validate(password.value);

    return !(userName.value.isSuccess && password.value.isSuccess);
  });

  function reset(): void {
    userName.value.val = "";
    password.value.val = "";
    userName.value.enabled = false;
    password.value.enabled = false;
  }

  return {
    userName,
    password,
    successForm,
    reset,
  };
}
